import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const PASClientAuthContext = createContext(null);

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const PASClientAuthProvider = ({ children }) => {
  const [pasClient, setPasClient] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('pas_client_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      fetchClient();
    } else {
      setLoading(false);
    }
  }, [token]);

  const fetchClient = async () => {
    try {
      const response = await axios.get(`${API}/pas-auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setPasClient(response.data);
    } catch (err) {
      console.error('Failed to fetch PAS client:', err);
      logout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const response = await axios.post(`${API}/pas-auth/login`, { email, password });
    const { token: newToken, client } = response.data;
    localStorage.setItem('pas_client_token', newToken);
    setToken(newToken);
    setPasClient(client);
    return response.data;
  };

  const register = async (userData) => {
    const response = await axios.post(`${API}/pas-auth/register`, userData);
    const { token: newToken, client } = response.data;
    localStorage.setItem('pas_client_token', newToken);
    setToken(newToken);
    setPasClient(client);
    return response.data;
  };

  const logout = () => {
    if (localStorage.getItem('pas_act')) {
      axios.post(`${API}/pas-auth/act/end`, {}, { headers: { Authorization: `Bearer ${localStorage.getItem('pas_client_token')}` } }).catch(() => {});
      localStorage.removeItem('pas_act');
      const prev = localStorage.getItem('pas_client_token_prev');
      localStorage.removeItem('pas_client_token_prev');
      if (prev) { localStorage.setItem('pas_client_token', prev); window.location.href = '/pas/admin/dashboard'; return; }
    }
    localStorage.removeItem('pas_client_token');
    setToken(null);
    setPasClient(null);
  };

  const refreshClient = async () => {
    if (token) {
      await fetchClient();
    }
  };

  return (
    <PASClientAuthContext.Provider value={{
      pasClient,
      token,
      loading,
      login,
      register,
      logout,
      refreshClient,
      isAuthenticated: !!pasClient
    }}>
      {children}
    </PASClientAuthContext.Provider>
  );
};

export const usePASClientAuth = () => {
  const context = useContext(PASClientAuthContext);
  if (!context) {
    throw new Error('usePASClientAuth must be used within a PASClientAuthProvider');
  }
  return context;
};
